import { useState } from 'react';
import { useSubscription } from '@apollo/client/react';

import {
    ITrainingPortfolioItemFragment,
    TrainingPortfolioItemDocument,
} from 'graphql/types';

interface IProps {
    children(data: ITrainingPortfolioItemFragment): React.ReactNode;
    trainingId: string;
    initialData?: ITrainingPortfolioItemFragment | null;
}

export const TrainingPortfolioItemSubscriptionData = ({
    children,
    trainingId,
    initialData,
}: IProps) => {
    const [portfolioItem, setPortfolioItem] = useState(initialData);

    useSubscription(TrainingPortfolioItemDocument, {
        variables: { trainingId },
        onData: ({ data: { data } }) => {
            const portfolioItem = data?.trainingPortfolioItem || null;

            setPortfolioItem(portfolioItem);
        },
    });

    if (!portfolioItem) return null;

    return <>{children(portfolioItem)}</>;
};
